<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">
        {{ $t("Edit") }} {{ $t("offer") }}& {{ $t("Voucher") }}
      </div>

      <router-link class="btn-blue" to="promotions-and-offers"
        >{{ $t("promotionsandoffer") }} {{ $t("list") }}</router-link
      >
    </div>
    <div class="white-wrapper">
      <section class="my-2">
        <div class="section-border container rounded-10 col-12 py-3 mb-2">
          <h5 class="heading">Applicable Cinemas</h5>

          <div class="row  my-3 pl-1 d-flex justify-content-between">
            <div class="d-flex align-self-center ml-4">
              <b-form-checkbox
                class="j-checkbox pb-0 ml-3"
                unchecked-value="N"
                value="Y"
                v-model="cinemaSettingsSection.isCinemaSettingsApplicable"
                @change="handleApplicableCinemaSettings($event)"
              ></b-form-checkbox>
              <div>
                {{ $t("applicableforselectedcinemasclassesntickettypes") }}
              </div>
            </div>
            <div class="col-1 d-flex justify-content-end align-items-center">
              <div
                class="icon-save-btn blue-icon mx-1 btn float-right"
                :title="'Save'"
                @click="updateCinemaSettingsSection"
              ></div>
            </div>
          </div>
          <template v-if="cinemaSettingsSection.cinemaSettings.length">
            <template
              v-for="(settingsObj,
              settingsIndex) in cinemaSettingsSection.cinemaSettings"
            >
              <div
                v-if="settingsObj.pvcs_is_active == 'Y'"
                class="row m-2 greyBackground mx-2 my-2 px-2 py-2"
                :key="settingsIndex"
              >
                <div class="col-11">
                  <div class="row whiteBackground">
                    <div class="col-12 d-flex align-items-center py-2">
                      <div class="d-flex align-items-center">
                        <span class="ml-1">Not Applicable </span>
                        <b-form-checkbox
                          v-model="settingsObj.is_settings_applicable"
                          unchecked-value="Y"
                          value="N"
                          class="j-checkbox pb-0 ml-2"
                          @change="
                            makeUpdatedCinemaSettingsData(
                              settingsIndex,
                              'applicableKey',
                              '',
                              $event
                            )
                          "
                        ></b-form-checkbox>
                      </div>
                    </div>
                    <div class="col-12 col-lg-2 my-2">
                      <div class="dropdown-curve-container">
                        <label
                          :class="
                            settingsObj.selectedCinema &&
                            settingsObj.selectedCinema.length
                              ? 'shift-up'
                              : 'font-weight-bold'
                          "
                        >
                          {{ $tc("cinema", 1) }}</label
                        >
                        <multiselect
                          v-model="settingsObj.selectedCinema"
                          :options="settingsObj.allowedCinemaList"
                          :multiple="true"
                          open-direction="bottom"
                          :placeholder="$tc('Cinemas')"
                          label="cine_name"
                          track-by="cine_id"
                          @remove="removeSelectedCinemas(settingsIndex, $event)"
                          @select="
                            makeUpdatedCinemaSettingsData(
                              settingsIndex,
                              'cinemas',
                              'add',
                              $event
                            )
                          "
                        >
                        </multiselect>
                      </div>
                    </div>
                    <div class="col-12 col-lg-3 my-2">
                      <div class="dropdown-curve-container">
                        <label
                          :class="
                            settingsObj.selectedScreens.length
                              ? 'shift-up'
                              : 'font-weight-bold'
                          "
                        >
                          {{ $tc("screens", 1) }}</label
                        >
                        <multiselect
                          v-model="settingsObj.selectedScreens"
                          :options="settingsObj.allowedScreenList"
                          open-direction="bottom"
                          :close-on-select="false"
                          placeholder="Screens"
                          label="screen_name"
                          group-values="screenData"
                          :group-select="true"
                          group-label="cine_name"
                          track-by="screen_id"
                          :multiple="true"
                          @select="
                            makeUpdatedCinemaSettingsData(
                              settingsIndex,
                              'screens',
                              'add'
                            )
                          "
                          @remove="
                            makeUpdatedCinemaSettingsData(
                              settingsIndex,
                              'screens',
                              'remove'
                            )
                          "
                        >
                        </multiselect>
                      </div>
                    </div>
                    <div class="col-12 col-lg-3 my-2">
                      <div class="dropdown-curve-container">
                        <label
                          :class="
                            settingsObj.selectedSeatTypes.length
                              ? 'shift-up'
                              : 'font-weight-bold'
                          "
                        >
                          Seat Types</label
                        >
                        <multiselect
                          v-model="settingsObj.selectedSeatTypes"
                          :options="masterData.seatGroups"
                          open-direction="bottom"
                          :close-on-select="false"
                          placeholder="Seat Groups"
                          label="sstg_name"
                          track-by="sstg_id"
                          :multiple="true"
                          @select="
                            makeUpdatedCinemaSettingsData(
                              settingsIndex,
                              'seatGroups',
                              'add'
                            )
                          "
                          @remove="
                            makeUpdatedCinemaSettingsData(
                              settingsIndex,
                              'seatGroups',
                              'remove'
                            )
                          "
                        >
                        </multiselect>
                      </div>
                    </div>
                    <div class="col-12 col-lg-3 my-2">
                      <div class="dropdown-curve-container">
                        <label
                          :class="
                            settingsObj.selectedTickets.length
                              ? 'shift-up'
                              : 'font-weight-bold'
                          "
                        >
                          Ticket Types</label
                        >
                        <multiselect
                          v-model="settingsObj.selectedTickets"
                          :options="masterData.ticketTypesData"
                          open-direction="bottom"
                          :close-on-select="false"
                          placeholder="Tickets"
                          label="tt_name"
                          track-by="tt_id"
                          :multiple="true"
                          @select="
                            makeUpdatedCinemaSettingsData(
                              settingsIndex,
                              'ticketTypes',
                              'add'
                            )
                          "
                          @remove="
                            makeUpdatedCinemaSettingsData(
                              settingsIndex,
                              'ticketTypes',
                              'remove'
                            )
                          "
                        >
                        </multiselect>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="col-1 greyBackground rounded-0 d-flex justify-content-center align-items-center"
                >
                  <button
                    class="btn-transparent mb-3"
                    @click="handleCinemaSettings('remove', settingsIndex)"
                  >
                    <img
                      src="@/assets/img/icons/minus.svg"
                      height="30"
                      width="30"
                    />
                  </button>
                </div>
              </div>
            </template>
            <div class="row justify-content-center">
              <button
                class="btn-transparent mb-3"
                @click="handleCinemaSettings('add')"
              >
                <img src="@/assets/img/icons/plus.svg" height="30" width="30" />
              </button>
            </div>
          </template>
        </div>
      </section>
    </div>
    <ImageGallery
      v-bind:propImageName="'Offer Image'"
      v-bind:openModal="offerContent.showModal"
      v-bind:set_height="offerContent.set_height"
      v-bind:set_width="offerContent.set_width"
      :showPercentageLoader="true"
      :img_desc="'Offer Image'"
      :resetImgData="false"
      :category="'Offer Image'"
    ></ImageGallery>
  </div>
</template>
<script>
  import { generateRandomCode } from "@/helper/collection";
  import MasterService from "@/services/MasterService";
  import MovieService from "@/services/MovieService";
  import moment from "moment";
  import PosFnBService from "@/services/Pos_Fnb_Service";
  import MarketingService from "@/services/MarketingService";
  import ClientService from "@/services/ClientService";
  import DatePicker from "vue2-datepicker";
  import VueTimepicker from "vue2-timepicker";
  import "vue2-timepicker/dist/VueTimepicker.css";
  import { VueEditor } from "vue2-editor";
  import ImageGallery from "../../ImageGallery/imageGalleryModal";
  import { mapGetters } from "vuex";
  import { BASEURL } from "@/config/index";
  import { CLIENT_NAME, CLIENT_NAMES_OBJ } from "@/helper/Role";

  let Start_Date = moment(
    `${moment()
      .subtract(1, "days")
      .format("YYYY-MM-DD")} 24:00:00`
  ).format();
  let End_date = moment(`${moment().format("YYYY-MM-DD")} 23:59:59`).format();

  export default {
    components: { DatePicker, VueTimepicker, VueEditor, ImageGallery },
    data() {
      return {
        offerSelected: true,
        voucherSelected: false,
        os_is_voucher: "N",
        titleName: "Offer",
        submit: {
          offer: false,
          offer_content: false,
          offer_movie: false,
          offer_days: false,
          offet_split: false,
          other_setting: false,
          offer_types: false,
          redemption_outlet: false,
        },
        //Collapse
        sectionCollapse: {
          offer: true,
          offer_content: false,
          cinema_configuration: false,
          movie_configuration: false,
          day_configuration: false,
          split_configuration: false,
          other_setting: false,
          offer_type: false,
          outlet: false,
          distributor_reporting: false,
        },
        selectedOfferGroupType: {},
        offer_id: null,
        offer: {
          os_is_active: "Y",
          offer_title: "",
          offer_code: generateRandomCode(8),
          offer_start_date_time: Start_Date,
          offer_end_date_time: End_date,
          offer_start_time: "06.00",
          offer_end_time: "05.59",
          offer_group_type_id: 1,
          offer_description_text: "",
          is_offer_auth_required: "N",
          visible_on_web: "N",
          is_redemption: "N",
          selectedOfferGroupType: {},
        },

        offerContent: {
          offerContentArray: [],
          pg_promo_code: [],
          activeIndex: 0,
          notempty: [false, false, false, false, false, false],
          uploadImageSType: "",
          bannerUpload: false,
          set_height: null,
          set_width: null,
          uploadIndex: null,
          showModal: null,
          isEdit: true,
          isEditHtml: false,
          banner_image_height: "690",
          banner_image_width: "2400",
          poster_image_height: "400",
          poster_image_width: "400",
        },
        check: [],
        voucherSettting: {
          oc_redemptions_per_patron: null,
          oc_total_redemptions: null,
        },
        offerMovieConfiguration: {
          os_is_foreign_movie_applicable: "N",
          os_movie_mf_id: "",
          os_is_movie_applicable: "Y",
          selectedMovieFormats: [],
          selectedParticaularMovies: [],
          movies_applicable_status: "movies_applicable",
          start_show_time: "",
          end_show_time: "",
        },

        offerDaysConfiguration: {
          offer_applicable_on_all_day: "Y",
          TrueFalseCount: null,
          weekDays: {
            selectAll: "Y",
            sunday: "Y",
            monday: "Y",
            tuesday: "Y",
            wednesday: "Y",
            thursday: "Y",
            friday: "Y",
            saturday: "Y",
          },
        },
        offerSplitConfiguration: {
          client_share_value: null,
          client_share_is_percentage: "Y",
          offer_dist_share_threshold: null,
          selectedClient: {},
        },
        offerSettingConfiguration: {
          is_bank_offer: "N",
          selectedOfferType: "fixedDiscount",
          selectedCard: [],
          bankDetails: {
            selectedBank: "",
            bank_id: null,
            card_type_ids: null,
            boc_id: null,
          },
          report_full_amount: "N",
          report_full_amount_special_rc: "N",
          has_o_reporting_percent: "N",
          o_reporting_percent: null,
        },
        offerTypes: {
          selectedOfferType: "fixedDiscount",
          is_employee_offer: "N",
          discountLists: [
            {
              oc_buy_no_of_ticket: "",
              oc_discount_value: "",
              oc_discount_value_is_percentage: "N",
              oc_max_discount_amount: null,
              oc_min_ticket_price: 0,
              oc_min_fnb_price: 0,
              min_amount_channel_wise: "N",
            },
          ],
          fixedDiscount: {
            oc_buy_no_of_ticket: null,
            oc_discount_value: null,
            oc_discount_value_is_percentage: "N",
            oc_max_discount_amount: null,
            oc_min_ticket_price: null,
            oc_min_fnb_price: null,
            min_amount_channel_wise: "N",
          },
          buyAndGetFreeTickets: {
            oc_buy_no_of_ticket: null,
            oc_get_free_ticket: null,
            oc_min_ticket_price: null,
            oc_max_no_of_ticket_per_transaction: null,
            oc_combine_with_other_offers: "N",
          },
          discount: {
            oc_buy_no_of_ticket: null,
            oc_discount_value: null,
            oc_discount_value_is_percentage: "N",
            oc_max_discount_amount: null,
          },
          loyalityProgramOffer: {
            oc_buy_no_of_ticket: null,
            oc_discount_value: null,
            oc_discount_value_is_percentage: "N",
            oc_max_discount_amount: null,
          },
          buyAndGetCombo: {
            offerApplicableAt: "boxOffice",
            boxOffice: {
              oc_buy_no_of_ticket: null,
              oc_get_item_id: null,
              oc_is_combo_free: "N",
              oc_discount_value: null,
              oc_discount_value_is_percentage: "N",
              selectedGetFnbItem: {},
            },
            F_And_B: {
              oc_buy_item_count: null,
              oc_get_item_count: null,
              oc_buy_item_id: null,
              oc_get_item_id: null,
              // SelectedOnFnBItem: null,
              // SelectedFreeFnBItem: null,
              selectedBuyFnbItem: {},
              selectedGetFnbItem: {},
              oc_is_combo_free: "N",
              oc_discount_value_is_percentage: "N",
              oc_discount_value: null,
            },
          },
          buyTicketFnbFixedPrice: {
            oc_buy_no_of_ticket: null,
            // oc_ticket_at_price: null,
            oc_min_ticket_price: null,
            oc_discount_value: null,
            oc_discount_value_is_percentage: "N",
            oc_max_no_of_ticket_per_transaction: null,
            oc_is_combo_with_fnb: "N",
            fnb_group_data: [
              {
                oc_buy_no_of_item: null,
                oc_buy_item_id: null,
                oc_buy_item_code: null,
                selectedFnbItem: {},
                oc_fnb_at_price: null,
              },
            ],
          },
          buyAndgetOffOnAnother: {
            oc_buy_no_of_ticket: null,
            oc_discount_value: "",
            oc_discount_value_is_percentage: "Y",
            oc_offer_on_higher_amount: "N",
            oc_max_no_of_ticket_per_transaction: null,
          },

          fnbItemDiscounts: [
            {
              pv_fnb_item_code: "",
              selectedFnbItem: {},
              pv_fnb_item_offer: null,
            },
          ],
        },

        redemptionOutletData: {
          selectedUsers: [],
          offer_redeem_at_online: "Y",
          offer_redeem_at_boxoffice: "Y",
          offer_redeem_at_concession: "N",
          offer_applicable_on: "gross",
          offer_applicable_on_gross_amount: "Y",
          offer_applicable_on_net_amount: "N",
        },
        signageImageData: {
          signageContainer: [
            {
              height: 1920,
              width: 1080,
              imageUrl: "",
            },
            {
              height: 1080,
              width: 1920,
              imageUrl: "",
            },
          ],
          cropSizeEnable: false,
          _downloadImagePath: null,
          uploadIndex: null,
        },
        masterData: {
          offerGroupTypes: [],
          movieFormats: [],
          movieList: [],
          cinemasList: [],
          clientList: [],
          activeBankList: [],
          activeBankCardList: [],
          fnbItems: [],
          ContentLanguages: [],
          ticketTypesData: [],
          seatGroups: [],
          userList: [],
        },
        cinemaSettingsSection: {
          isCinemaSettingsApplicable: "N",
          cinemaSettings: [],
          rejectedCinemaIds: [],
          availableCinemasList: [],
        },
        distributorSection: {
          distributorData: [],
        },
        sendPayload: {
          movieList: [],
          cinemaSettingsList: [],
          fnbDiscountdata: [],
          distributorShareData: [],
        },
        custom_errors: {
          only_cinema_error: "",
          weekday_errors: "",
          voucher_start_date_error: "",
        },
      };
    },
    watch: {
      finalImagePath(newVal) {
        if (this.offerContent.uploadImageType == 1) {
          this.offerContent.offerContentArray[
            this.offerContent.activeIndex
          ].offer_banner_image = newVal;
        }
        if (this.offerContent.uploadImageType == 3) {
          this.signageImageData.signageContainer[
            this.offerContent.uploadIndex
          ].imageUrl = newVal;
        }
        if (this.offerContent.uploadImageType == 2) {
          this.offerContent.offerContentArray[
            this.offerContent.activeIndex
          ].offer_poster_image = newVal;
        }
        this.$forceUpdate();
      },
      "sectionCollapse.distributor_reporting": function(newValue) {
        if (newValue === true && this.masterData.seatGroups.length === 0) {
          this.getSeatGroups();
          this.getTicketType();
        }
        if (
          newValue === true &&
          this.distributorSection.distributorData.length === 0
        ) {
          this.handleDistributorRowAction("add");
        }
      },
    },
    computed: {
      ...mapGetters(["finalImagePath"]),
      showGrossNetButton() {
        return CLIENT_NAMES_OBJ.EPIX.includes(String(this.CLIENT_SETUP_NAME));
      },
      showForeignMovieSection() {
        return CLIENT_NAMES_OBJ.showForeignMovieSection.includes(
          String(this.CLIENT_SETUP_NAME)
        );
      },
      isEpix() {
        return CLIENT_NAMES_OBJ.EPIX.includes(String(this.CLIENT_SETUP_NAME));
      },
    },

    beforeMount() {
      let cinemaid =
        this.secureStore.get("USINFO") &&
        this.secureStore.get("USINFO")["cinema_id"]
          ? this.secureStore.get("USINFO").cinema_id
          : null;
      let roleid = this.secureStore.get("USINFO").role_id;

      if (roleid == 3) {
        this.$router.go(-1);
      } else {
        const { os_id } = this.$route.query;
        if (os_id) {
          this.offer_id = os_id;
        } else {
          this.$router.go(-1);
        }
      }
      Promise.all([
        this.getMovieFormats(),
        this.getCinemasList(),
        this.getActiveMovies(),
        this.getClientList(),
        this.getBankList(),
        this.getFnBItems(),
        this.getUserList(),
        this.getContentLangauge(),
        this.getOfferGroupType(),
        this.getSeatGroups(),
        this.getTicketType(),
      ]).then(() => {
        this.getOfferPromotionVoucherData();
      });
    },
    methods: {
      uniqueCinemaList(cinemasData) {
        if (!cinemasData.length) return [];

        let resultCinemasArr = [];
        cinemasData.forEach((cinemasObj) => {
          let cinemaIndex = resultCinemasArr.findIndex((cinemasIndexObj) => {
            return cinemasIndexObj.cine_id == cinemasObj.cine_id;
          });

          if (cinemaIndex < 0) {
            resultCinemasArr.push(cinemasObj);
          }
        });
        return resultCinemasArr;
      },
      handleApplicableCinemaSettings(event) {
        if (event == "Y" && !this.cinemaSettingsSection.cinemaSettings.length) {
          this.cinemaSettingsSection.cinemaSettings.push({
            selectedCinema: [],
            allowedCinemaList: this.masterData.cinemasList,
            allowedScreenList: [],
            cinemaScreens: [],
            selectedScreens: [],
            selectedSeatTypes: [],
            selectedTickets: [],
            is_settings_applicable: "Y",
            pvcs_id: null,
          });
          this.cinemaSettingsSection.availableCinemasList = this.masterData.cinemasList.map(
            (cinemasObj) => {
              return { ...cinemasObj };
            }
          );
        } else {
          if (this.sendPayload.cinemaSettingsList.length) {
            this.sendPayload.cinemaSettingsList.forEach((cinemaObj) => {
              cinemaObj.pvcs_is_active = "N";
            });
          }
          this.cinemaSettingsSection.cinemaSettings = [];
        }
      },
      async handleCinemaSettings(type, index = null) {
        if (type === "add") {
          // let data = await this.getCinemaNewList();
          // if (!this.cinemaSettingsSection.availableCinemasList.length) {
          //   return this.$toasted.show("cinemas is not availble for next row");
          // }
          let currentSelectedCinemas = this.cinemaSettingsSection.cinemaSettings.map(
            (cinemasObj) => {
              let cinemasData = cinemasObj.selectedCinema.map(
                (selectedCinemaObj) => {
                  return String(selectedCinemaObj.cine_id);
                }
              );
              return cinemasData;
            }
          );
          let availableCinemasList = this.masterData.cinemasList.map(
            (cinemasObj) => {
              return { ...cinemasObj };
            }
          );
          if (currentSelectedCinemas.length) {
            let flatCurrentCinemas = currentSelectedCinemas.flatMap(
              (flatCinemasData) => {
                return flatCinemasData;
              }
            );
            availableCinemasList = this.masterData.cinemasList.filter(
              (cinemasObj) => {
                return !flatCurrentCinemas.includes(String(cinemasObj.cine_id));
              }
            );
          }
          if (!availableCinemasList.length) {
            return this.$toasted.show(`All cinema settings are added`);
          }
          this.cinemaSettingsSection.cinemaSettings.push({
            selectedCinema: [],
            cinemaScreens: [],
            allowedCinemaList: this.uniqueCinemaList(availableCinemasList),
            allowedScreenList: [],
            selectedScreens: [],
            selectedSeatTypes: [],
            selectedTickets: [],
            is_settings_applicable: "Y",
            pvcs_id: null,
            pvcs_is_active: "Y",
          });
        } else {
          this.cinemaSettingsSection.cinemaSettings[index].pvcs_is_active = "N";

          let cinemaDataRemovedRow = this.cinemaSettingsSection.cinemaSettings[
            index
          ].selectedCinema;

          this.cinemaSettingsSection.cinemaSettings.forEach((cinemasObj) => {
            if (cinemasObj.pvcs_is_active == "Y") {
              cinemasObj.allowedCinemaList = this.uniqueCinemaList([
                ...cinemasObj.allowedCinemaList,
                ...cinemaDataRemovedRow,
              ]);
            }
          });
          this.$forceUpdate();

          if (!this.cinemaSettingsSection.cinemaSettings.length) {
            this.cinemaSettingsSection.isCinemaSettingsApplicable = "N";
          }
        }
      },
      handleCinemaScreenChange(index, event) {
        // if (event[event.length-1].screen_id === "all") {
        //   this.cinemaSettingsSection.cinemaSettings[index].cinemaScreens = this.cinemaSettingsSection.cinemaSettings[index].cinemaScreens.map(screens => ({ ...screens, $isDisabled: true }))
        // }
      },
      removeSelectedCinemas(settingsIndex, event) {
        let pvcsIndex = -1;
        // if (this.cinemaSettingsSection.cinemaSettings[settingsIndex].pvcs_id) {
        //   pvcsIndex = this.sendPayload.cinemaSettingsList.findIndex(pvcsObj => pvcsObj.pvcs_id == this.cinemaSettingsSection.cinemaSettings[settingsIndex].pvcs_id)
        // }
        let updatedAvailableCinemas = this.masterData.cinemasList.filter(
          (filteredCinemasObj) => {
            return filteredCinemasObj.cine_id == event.cine_id;
          }
        );
        let updateAvailableScreens = this.cinemaSettingsSection.cinemaSettings[
          settingsIndex
        ].selectedScreens.filter((screensobj) => {
          return screensobj.cinema_id != event.cine_id;
        });
        console.log(event, updatedAvailableCinemas);
        // this.cinemaSettingsSection.availableCinemasList.push(event)
        this.cinemaSettingsSection.cinemaSettings.forEach(
          (cinemasObj, cinemaIndex) => {
            cinemasObj.allowedCinemaList = this.uniqueCinemaList([
              ...cinemasObj.allowedCinemaList,
              ...updatedAvailableCinemas,
            ]);
            if (settingsIndex == cinemaIndex) {
              cinemasObj.selectedScreens = [...updateAvailableScreens];
            }
          }
        );
        console.log(
          { event },
          "remove",
          this.cinemaSettingsSection.cinemaSettings
        );
        let currentSelectedCinemaList = this.cinemaSettingsSection.cinemaSettings[
          settingsIndex
        ].selectedCinema.filter((filterCinemasObj) => {
          return filterCinemasObj.cine_id != event.cine_id;
        });
        this.updateScreenListCinemaWise(
          currentSelectedCinemaList,
          settingsIndex
        );
      },
      makeUpdatedCinemaSettingsData(index, type, action = "", event) {
        console.log({ event }, "makeUpdatedCinemaSettingsData");
        let pvcsIndex = -1;
        if (this.cinemaSettingsSection.cinemaSettings[index].pvcs_id) {
          pvcsIndex = this.sendPayload.cinemaSettingsList.findIndex(
            (screenObj) =>
              screenObj.pvcs_id ==
              this.cinemaSettingsSection.cinemaSettings[index].pvcs_id
          );
        }

        if (type == "cinemas") {
          let cinemaDataList = this.cinemaSettingsSection.cinemaSettings[index]
            .selectedCinema.length
            ? this.cinemaSettingsSection.cinemaSettings[
                index
              ].selectedCinema.map((cinemaData) => String(cinemaData.cine_id))
            : [];

          if (pvcsIndex >= 0) {
            if (!cinemaDataList.length) {
              this.sendPayload.cinemaSettingsList[pvcsIndex].all_cinema_id = "";
              console.log("no cinema found, so returned empty");
              return;
            }
            this.sendPayload.cinemaSettingsList[
              pvcsIndex
            ].all_cinema_id = cinemaDataList.join(",");
          }

          this.cinemaSettingsSection.cinemaSettings.forEach((cinemasObj) => {
            cinemasObj.allowedCinemaList = this.uniqueCinemaList(
              cinemasObj.allowedCinemaList.filter((filteredCinemasObj) => {
                return event.cine_id != filteredCinemasObj.cine_id;
              })
            );
          });

          this.updateScreenListCinemaWise(
            [
              ...this.cinemaSettingsSection.cinemaSettings[index]
                .selectedCinema,
              event,
            ],
            index
          ); //this.cinemaSettingsSection.cinemaSettings[index].selectedCinema only get set after the function execution is completed. So used spread operator to add current object
        } else if (false && type == "screens" && pvcsIndex >= 0) {
          this.sendPayload.cinemaSettingsList[pvcsIndex].all_screen_ids = this
            .cinemaSettingsSection.cinemaSettings[index].selectedScreens.length
            ? this.cinemaSettingsSection.cinemaSettings[index].selectedScreens
                .map((screensData) => screensData.screen_id)
                .join(",")
            : "";
        } else if (false && type == "seatGroups" && pvcsIndex >= 0) {
          this.sendPayload.cinemaSettingsList[
            pvcsIndex
          ].all_seat_group_type_id = this.cinemaSettingsSection.cinemaSettings[
            index
          ].selectedSeatTypes.length
            ? this.cinemaSettingsSection.cinemaSettings[index].selectedSeatTypes
                .map((seatsData) => seatsData.sstg_id)
                .join(",")
            : "";
        } else if (false && type == "ticketTypes" && pvcsIndex >= 0) {
          this.sendPayload.cinemaSettingsList[pvcsIndex].all_tt_id = this
            .cinemaSettingsSection.cinemaSettings[index].selectedTickets.length
            ? this.cinemaSettingsSection.cinemaSettings[index].selectedTickets
                .map((ticketsData) => ticketsData.tt_id)
                .join(",")
            : "";
        } else if (false && type == "applicableKey" && pvcsIndex >= 0) {
          this.sendPayload.cinemaSettingsList[
            pvcsIndex
          ].is_settings_applicable = event;
        }
      },
      async updateCinemaSettingsSection() {
        if (this.cinemaSettingsSection.cinemaSettings.length) {
          this.sendPayload.cinemaSettingsList = [];
          this.cinemaSettingsSection.cinemaSettings.forEach(
            (cinemaSettingObj) => {
              let cinemaSettingPayloadObj = {
                pvcs_id: cinemaSettingObj.pvcs_id
                  ? cinemaSettingObj.pvcs_id
                  : null,
                is_settings_applicable: cinemaSettingObj.is_settings_applicable,
                all_cinema_id: cinemaSettingObj.selectedCinema.length
                  ? cinemaSettingObj.selectedCinema
                      .map((cinema) => cinema.cine_id)
                      .join(",")
                  : "",
                all_screen_ids: cinemaSettingObj.selectedScreens.length
                  ? cinemaSettingObj.selectedScreens
                      .map((screenObj) => screenObj.screen_id)
                      .join(",")
                  : "",
                all_seat_group_type_id: cinemaSettingObj.selectedSeatTypes
                  .length
                  ? cinemaSettingObj.selectedSeatTypes
                      .map((seatObj) => seatObj.sstg_id)
                      .join(",")
                  : "",
                all_tt_id: cinemaSettingObj.selectedTickets.length
                  ? cinemaSettingObj.selectedTickets
                      .map((ticketObj) => ticketObj.tt_id)
                      .join(",")
                  : "",
                pvcs_is_active: cinemaSettingObj.pvcs_is_active
                  ? cinemaSettingObj.pvcs_is_active
                  : "Y",
              };
              //       console.log({ cinemaSettingPayloadObj })

              this.sendPayload.cinemaSettingsList.push(cinemaSettingPayloadObj);
            }
          );
        }

        const payload = {
          offersCinema: this.sendPayload.cinemaSettingsList.length
            ? this.sendPayload.cinemaSettingsList
            : [],
        };

        await this.onSubmit(payload, "offersCinemaSettingsSection");
        await this.getOfferPromotionVoucherData();
      },

      async getCinemaScreens(index, type = "setData", cinema_id = null) {
        try {
          const response = await MasterService.GetActiveList({
            tableName: "screens",
            screen_is_active: "Y",
            cinema_id: cinema_id
              ? cinema_id
              : this.cinemaSettingsSection.cinemaSettings[index].selectedCinema
                  .cine_id,
          });
          const { data } = response;
          if (data.status && data.Records.length > 0 && index >= 0) {
            if (type == "setData") {
              this.cinemaSettingsSection.cinemaSettings[index][
                "cinemaScreens"
              ] = [{ screen_id: "all", screen_name: "All" }, ...data.Records];
            } else {
              return [
                { screen_id: "all", screen_name: "All" },
                ...data.Records,
              ];
            }
          } else {
            // Show Errors
            if (type != "setData") {
              return [];
            }
            console.log("show error:", data.message);
          }
        } catch (error) {
          this._CatchError(error);
        }
      },
      async getSeatGroups() {
        let loader;
        try {
          loader = this.$loading.show();
          const response = await MasterService.GetActiveList({
            tableName: "ms_screen_seat_type_group",
            sstg_is_active: "Y",
          });
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.masterData.seatGroups = [...data.Records];
          } else {
            // Show Errors
            console.log("show error:", data.message);
          }
        } catch (error) {
          this._CatchError(error);
        } finally {
          if (loader) {
            loader.hide();
          }
        }
      },
      async getTicketType() {
        let loader;
        try {
          loader = this.$loading.show();
          const response = await MasterService.GetActiveList({
            tableName: "ms_ticket_type",
            tt_is_active: "Y",
          });
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.masterData.ticketTypesData = [...data.Records];
          } else {
            // Show Errors
            console.log("show error:", data.message);
          }
        } catch (error) {
          this._CatchError(error);
        } finally {
          if (loader) {
            loader.hide();
          }
        }
      },
      async getOfferGroupType() {
        let loader;
        try {
          loader = this.$loading.show();
          const response = await MarketingService.GetAllOfferGroupType({
            status: "Active",
          });
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.masterData.offerGroupTypes = data.Records;
          } else {
            console.log("Error:", data.message);
            this.$toasted.show(data.message);
          }
        } catch (err) {
          console.log("Error:", err);
        } finally {
          if (loader) {
            loader.hide();
          }
        }
      },
      async getMovieFormats() {
        let loader;
        try {
          loader = this.$loading.show();
          const response = await MasterService.GetActiveList({
            tableName: "ms_movie_formats",
            mf_is_active: "Y",
          });
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.masterData.movieFormats = data.Records;
          } else {
            // Show Errors
            this.$toasted.show(data.message);
            console.log("show error:", data.message);
          }
        } catch (error) {
          this._CatchError(error);
        } finally {
          if (loader) {
            loader.hide();
          }
        }
      },
      handleMovieApplicableChange(selected) {
        this.offerMovieConfiguration.movies_applicable_status = selected;
        if (selected === "movies_applicable") {
          this.offerMovieConfiguration.os_is_movie_applicable = "Y";
        } else if (selected === "movies_not_applicable") {
          this.offerMovieConfiguration.os_is_movie_applicable = "N";
        }
      },
      handleRadioChange(selected) {
        if (selected === "gross") {
          this.redemptionOutletData.offer_applicable_on_gross_amount = "Y";
          this.redemptionOutletData.offer_applicable_on_net_amount = "N";
        } else if (selected === "net") {
          this.redemptionOutletData.offer_applicable_on_gross_amount = "N";
          this.redemptionOutletData.offer_applicable_on_net_amount = "Y";
        }
      },
      async getActiveMovies() {
        this.masterData.movieList = [];
        let loader;
        try {
          loader = this.$loading.show();
          const response = await MovieService.GetActiveMoviesWithFormat({
            movieversions: "Y",
          });
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.masterData.movieList = data.Records;
          } else {
            this.$toasted.show(data.message || this.AdminError);
          }
        } catch (error) {
          this._CatchError(error);
        } finally {
          if (loader) {
            loader.hide();
          }
        }
      },
      makeActiveInactive: function(event, index, action = "", name = "") {
        if (action == "add") {
          let obj = { ...event };
          // making keys active based on type of updating section
          // name == "movieList" && (obj.pvms_is_active = "Y");
          // name == "fnbDiscountdata" && (obj.is_active = true);
          // name == "cinemaSettings" && (obj.pvcs_is_active="Y")

          if (name === "fnbDiscountdata") {
            let fnbIndex = -1;
            if (this.offerTypes.fnbItemDiscounts[index].pv_fnb_id) {
              fnbIndex = this.sendPayload.fnbDiscountdata.findIndex(
                (row) =>
                  row.pv_fnb_id ==
                  this.offerTypes.fnbItemDiscounts[index].pv_fnb_id
              );
            }

            if (fnbIndex >= 0) {
              this.sendPayload.fnbDiscountdata[
                fnbIndex
              ].selectedFnbItem = event;
            }
          }
        } else if (action == "remove") {
          if (name == "movieList") {
            let movieIndex = this.sendPayload[name].findIndex(
              (obj) => obj.pvms_id == event.pvms_id
            );
            if (movieIndex >= 0) {
              this.sendPayload[name][movieIndex].pvms_is_active = "N";
            }
          } else {
            let fnbIndex = -1;
            if (this.offerTypes.fnbItemDiscounts[index].pv_fnb_id) {
              fnbIndex = this.sendPayload.fnbDiscountdata.findIndex(
                (row) =>
                  row.pv_fnb_id ==
                  this.offerTypes.fnbItemDiscounts[index].pv_fnb_id
              );
            }

            if (fnbIndex >= 0) {
              this.sendPayload.fnbDiscountdata[fnbIndex].selectedFnbItem = {};
            }
          }
        }
      },
      onChangeFnbItem(event, rowIndex) {},
      onChangeWeekdays: function(event, keyname) {
        this.offerDaysConfiguration.TrueFalseCount = 0;
        const weekDays = this.offerDaysConfiguration.weekDays;
        if (keyname === "selectAll") {
          const newValue = event === "Y" ? "Y" : "N";
          Object.keys(weekDays).forEach((day) => {
            weekDays[day] = newValue;
          });
          this.offerDaysConfiguration.offer_applicable_on_all_day = newValue;
        } else {
          weekDays[keyname] = event;
          if (event === "N" && weekDays["selectAll"] === "Y") {
            weekDays["selectAll"] = "N";
            this.offerDaysConfiguration.offer_applicable_on_all_day = "N";
          } else {
            const allDaysSelected = Object.keys(weekDays).every((day) => {
              return day === "selectAll" || weekDays[day] === "Y";
            });

            weekDays["selectAll"] = allDaysSelected ? "Y" : "N";
            this.offerDaysConfiguration.offer_applicable_on_all_day = allDaysSelected
              ? "Y"
              : "N";
          }
        }
        Object.keys(weekDays).map((x) => {
          if (x != "selectAll") {
            if (weekDays[x] === "N") {
              this.offerDaysConfiguration.TrueFalseCount++;
            }
          }
        });
      },

      async getClientList() {
        let loader;
        try {
          loader = this.$loading.show();
          const response = await ClientService.GetAllClients({});
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.masterData.clientList = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        } catch (error) {
          this.$toasted.show(error);
        } finally {
          if (loader) {
            loader.hide();
          }
        }
      },
      async getUserList() {
        let loader;
        try {
          loader = this.$loading.show();
          const response = await MarketingService.GETUSERLIST();
          const { data } = response;
          console.log("response------>", response);
          if (data && data.status && data.Records && data.Records.length > 0) {
            this.masterData.userList = [...data.Records];
          } else {
            this.$toasted.show(data.message || "Opps! Something went wrong");
          }
        } catch (error) {
          this._CatchError(error);
        } finally {
          if (loader) {
            loader.hide();
          }
        }
      },
      onSelectEmployeeDiscount(event) {
        this.offerSettingConfiguration.selectedOfferType = "fixedDiscount";
      },

      onSelectBankOffer(event) {
        this.offerTypes.is_employee_offer = "N";
        if (event == "N") {
          this.offerSettingConfiguration.bankDetails = {
            selectedBank: "",
            bank_id: null,
            card_type_ids: null,
          };
          this.offerSettingConfiguration.selectedCard = [];
        }
      },
      async getBankList() {
        let loader;
        try {
          loader = this.$loading.show();
          const response = await MarketingService.GetActiveBanks();
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.masterData.activeBankList = data.Records;
          } else {
            this.$toasted.show(data.message || "Oops! Something went wrong");
          }
        } catch (error) {
          this._CatchError(error);
        } finally {
          if (loader) {
            loader.hide();
          }
        }
      },
      onSelectBankv2(event, type) {
        if (type == "REMOVE") {
          this.offerSettingConfiguration.bankDetails["bank_id"] = null;
          this.offerSettingConfiguration.bankDetails["selectedBank"] = "";
          this.offerSettingConfiguration.selectedCard = [];
          this.masterData.activeBankCardList = [];
        } else {
          this.offerSettingConfiguration.bankDetails["bank_id"] =
            event["bank_id"];
          // this.offerSettingConfiguration.selectedCard = [];
        }
        this.getBankCards();
      },
      handleMaxDiscount() {
        this.offerTypes.discount.oc_max_discount_amount = this.offerTypes.discount.oc_discount_value;
      },
      async getBankCards() {
        this.masterData.activeBankCardList = [];

        let bankId =
          this.offerSettingConfiguration.bankDetails["bank_id"] || null;
        if (bankId) {
          try {
            const response = await MarketingService.GetActiveBanksCards(
              this.offerSettingConfiguration.bankDetails["bank_id"]
            );
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.masterData.activeBankCardList = data.Records;
              this.offerSettingConfiguration.selectedCard = [];
            } else {
              this.$toasted.show(data.message || "Oops! Something went wrong");
            }
          } catch (error) {
            this._CatchError(error);
          }
        } else {
          this.masterData.activeBankCardList = [];
        }
      },
      onSelectCardTypes(event, type) {
        if (type == "ADD") {
          let IdsArray = this.offerSettingConfiguration.bankDetails[
            "card_type_ids"
          ]
            ? this.offerSettingConfiguration.bankDetails["card_type_ids"].split(
                ", "
              )
            : [];
          IdsArray.push(event["card_id"]);
          if (IdsArray.length) {
            this.offerSettingConfiguration.bankDetails[
              "card_type_ids"
            ] = IdsArray.join(", ");
          }
        } else if (type == "REMOVE") {
          let removeId = event["card_id"] || null;
          let tempArray =
            this.offerSettingConfiguration.bankDetails["selectedCard"] &&
            this.offerSettingConfiguration.bankDetails["selectedCard"].length
              ? this.offerSettingConfiguration.bankDetails[
                  "selectedCard"
                ].filter((y) => y.card_id != removeId)
              : [];
          let IdsArray = [];
          if (tempArray.length) {
            IdsArray = tempArray.map((x) => x.card_id);
          }
          if (IdsArray.length) {
            this.offerSettingConfiguration.bankDetails[
              "card_type_ids"
            ] = IdsArray.join(", ");
          } else {
            this.offerSettingConfiguration.bankDetails["card_type_ids"] = null;
          }
        }
      },
      checkOfferTypeAvailable(offerType) {
        if (this.offerTypes.is_employee_offer == "Y") {
          if (offerType == "fixedDiscount") {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      },
      onChangeOfferType(event) {
        if (event == "buyAndGetFreeTickets") {
          this.redemptionOutletData.offer_redeem_at_concession = "N";
        } else if (event == "fixedPriceTicketFnb") {
          this.redemptionOutletData.offer_redeem_at_concession = "N";
        } else if (event == "buyAndgetOffOnAnother") {
          this.redemptionOutletData.offer_redeem_at_concession = "N";
        } else if (event == "fnbItemDiscounts") {
          this.redemptionOutletData.offer_redeem_at_boxoffice = "N";
          this.redemptionOutletData.offer_redeem_at_concession = "Y";
        }
      },
      onChangeChannelWise(event) {
        this.offerTypes.fixedDiscount.oc_min_fnb_price = 0;
      },
      async getFnBItems() {
        let loader;
        try {
          loader = this.$loading.show();
          const response = await MarketingService.GetAllFNBItems();
          const { data } = response;
          if (data && data.status && data.Records && data.Records.length > 0) {
            this.masterData.fnbItems = data.Records;
          } else {
            this.$toasted.show(data.message || "Opps! Something went wrong");
          }
        } catch (error) {
          this._CatchError(error);
        } finally {
          if (loader) {
            loader.hide();
          }
        }
      },
      onChangeCount(event, offerType, type) {
        let value = event.target.value;
        if (offerType == "buyTicketFnbFixedPrice") {
          if (type == "buy") {
            this.offerTypes.buyTicketFnbFixedPrice.oc_max_no_of_ticket_per_transaction = value;
          } else if (type == "max") {
            if (
              value &&
              this.offerTypes.buyTicketFnbFixedPrice.oc_buy_no_of_ticket &&
              parseInt(
                this.offerTypes.buyTicketFnbFixedPrice.oc_buy_no_of_ticket
              ) > parseInt(value)
            ) {
              this.offerTypes.buyTicketFnbFixedPrice.oc_max_no_of_ticket_per_transaction = this.offerTypes.buyTicketFnbFixedPrice.oc_buy_no_of_ticket;
              this.$toasted.show(
                "Max Limit Must be Greater or Equal to No. of Buy Tickets"
              );
              this.$forceUpdate();
            }
          }
        } else if (offerType == "buyAndgetOffOnAnother") {
          if (type == "buy") {
            this.offerTypes.buyAndgetOffOnAnother.oc_max_no_of_ticket_per_transaction = value;
          } else if (type == "max") {
            if (
              value &&
              this.offerTypes.buyAndgetOffOnAnother.oc_buy_no_of_ticket &&
              parseInt(
                this.offerTypes.buyAndgetOffOnAnother.oc_buy_no_of_ticket
              ) > parseInt(value)
            ) {
              this.offerTypes.buyAndgetOffOnAnother.oc_max_no_of_ticket_per_transaction = this.offerTypes.buyAndgetOffOnAnother.oc_buy_no_of_ticket;
              this.$toasted.show(
                "Max Limit Must be Greater or Equal to No. of Buy Tickets"
              );
              this.$forceUpdate();
            }
          }
        }
      },
      selectFnbItemFixedOffer(event, index, type) {
        if (type == "Add") {
          this.offerTypes.buyTicketFnbFixedPrice.fnb_group_data[
            index
          ].oc_buy_item_id = event.item_id;
          this.offerTypes.buyTicketFnbFixedPrice.fnb_group_data[
            index
          ].oc_buy_item_code = event.item_code;
          this.offerTypes.buyTicketFnbFixedPrice.fnb_group_data[
            index
          ].selectedFnbItem = {
            item_id: event.item_id,
            item_name: event.item_name,
            item_code: event.item_code,
          };
        } else if (type == "Remove") {
          this.offerTypes.buyTicketFnbFixedPrice.fnb_group_data[
            index
          ].oc_buy_item_id = null;
          this.offerTypes.buyTicketFnbFixedPrice.fnb_group_data[
            index
          ].oc_buy_item_code = "";
          this.offerTypes.buyTicketFnbFixedPrice.fnb_group_data[
            index
          ].selectedFnbItem = "";
        }
      },
      addFnbCriteria() {
        let fnbObj = {
          oc_buy_no_of_item: null,
          oc_buy_item_id: null,
          oc_buy_item_code: null,
          selectedFnbItem: "",
          oc_fnb_at_price: null,
        };
        this.offerTypes.buyTicketFnbFixedPrice.fnb_group_data.push(fnbObj);
      },
      removeFnbCriteria(index) {
        this.offerTypes.buyTicketFnbFixedPrice.fnb_group_data.splice(index, 1);
      },

      addFnbItemDiscountRow() {
        this.offerTypes.fnbItemDiscounts.push({
          pv_fnb_item_code: "",
          pv_fnb_item_offer: null,
          selectedFnbItem: {},
        });
      },
      removeFnbItemDiscountRow(rowIndex) {
        let fnbIndex = -1;
        if (
          this.offerTypes.fnbItemDiscounts[rowIndex] &&
          this.offerTypes.fnbItemDiscounts[rowIndex].pv_fnb_id
        ) {
          fnbIndex = this.sendPayload.fnbDiscountdata.findIndex(
            (row) =>
              row.pv_fnb_id ==
              this.offerTypes.fnbItemDiscounts[rowIndex].pv_fnb_id
          );
        }

        if (fnbIndex >= 0) {
          this.sendPayload.fnbDiscountdata[fnbIndex].pv_fnb_is_active = "N";
        }

        this.offerTypes.fnbItemDiscounts.splice(rowIndex, 1);
      },
      onChangeTabHandler: function(event, index) {
        this.offerContent.activeIndex = index;
      },
      CheckEmptyContent: function(Content, index) {
        if (Content.langauge.toLowerCase() !== "english") {
          if (Content.offer_title) {
            this.offerContent.notempty[index] = true;
          } else {
            this.offerContent.notempty[index] = false;
          }
        }
      },
      onChangeReporting(event, type) {
        if (type == "full" || type == "full_spcl") {
          this.offerSettingConfiguration.o_reporting_percent = null;
          this.offerSettingConfiguration.has_o_reporting_percent = "N";
        } else if (type == "specific") {
          this.offerSettingConfiguration.report_full_amount_special_rc = "N";
          this.offerSettingConfiguration.report_full_amount = "N";
        }
      },
      setModalData(height, width, contentIndex = null, type = 1) {
        this.offerContent.uploadImageType = type;
        this.offerContent.bannerUpload = false;
        this.$forceUpdate();
        this.offerContent.set_height = height;
        this.offerContent.set_width = width;
        this.offerContent.uploadIndex = contentIndex;
        this.offerContent.showModal = !this.offerContent.showModal;
        if (type == 3) {
          this.signageImageData.cropSizeEnable = false;
        } else {
          this.signageImageData.cropSizeEnable = true;
        }
      },
      onChangeTranslationInput(event, content, contentIndex, item) {
        this.CheckEmptyContent(content, contentIndex);
      },
      async getContentLangauge() {
        let loader;
        try {
          loader = this.$loading.show();
          const response = await MovieService.GetMovieContentLanguages();
          const { data } = response;
          if (data && data.status && data.ContentLanguages.length) {
            this.masterData.ContentLanguages = data.ContentLanguages;
            data.ContentLanguages.forEach((x) => {
              let Obj = {
                ...x,
                offer_title: "",
                offer_description: "",
                offer_banner_image: "",
                offer_poster_image: "",
              };
              this.offerContent.offerContentArray.push(Obj);
            });
          } else {
            this.$toasted.show(data.message);
            console.log("data.message :", data.message);
          }
          // this.makeLangContainers();
        } catch (error) {
          console.log("Catch Error :", error);
        } finally {
          if (loader) {
            loader.hide();
          }
        }
      },

      // makeLangContainers: function () {
      //   this.masterData.ContentLanguages.forEach((x) => {
      //     let Obj = {
      //       ...x,
      //       offer_title: "",
      //       offer_description: "",
      //       offer_banner_image: "",
      //       offer_poster_image: "",
      //     };
      //     this.offerContent.offerContentArray.push(Obj);
      //     console.log(
      //       "this.offerContentArray",
      //       this.offerContent.offerContentArray
      //     );
      //   });
      // },
      onChangeText(event, type) {
        this.offerContent.offerContentArray.map((x) => {
          if (x.langauge.toLowerCase() == "english") {
            if (type == "name") {
              x.offer_title = event.target.value;
            } else if (type == "desc") {
              x.offer_description = event.target.value;
            }
          }
        });
      },
      async getCinemasList() {
        this.masterData.cinemasList = [];
        let loader;
        try {
          loader = this.$loading.show();

          const response = await MasterService.GetActiveList({
            tableName: "ms_cinemas",
            cine_is_active: "Y",
          });
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.masterData.cinemasList = data.Records;
            console.log("cinema list old=> ", this.masterData.cinemasList);

            this.offerContent.pg_promo_code = data.Records.map((c) => ({
              pg_promo_code: "",
              cine_id: c.cine_id,
              cine_name: c.cine_name,
            }));
          } else {
            this.$toasted.show(data.message || this.AdminError);
          }
        } catch (error) {
          this._CatchError(error);
        } finally {
          if (loader) {
            loader.hide();
          }
        }
      },
      async getCinemaNewList() {
        let loader;
        try {
          let payload = {
            reject_cinema_ids: this.cinemaSettingsSection.rejectedCinemaIds,
          };
          let response = await MarketingService.getCinemaList(payload);
          let { data } = response;
          if (data && data.status && data.Records.length) {
            this.masterData.cinemasList = data.Records;
            return data.Records;
          } else {
            console.log(data.message);
          }
        } catch (error) {
          this._CatchError(error);
        } finally {
          if (loader) {
            loader.hide();
          }
        }
      },
      async updateScreenListCinemaWise(event, index) {
        console.log({ event });
        let loader = this.$loading.show();
        try {
          let cinema_ids = [];

          if (event) {
            cinema_ids = event.map((cinema) => cinema.cine_id).join(",");

            console.log("cinema id arrau fetch function=>", cinema_ids);
            let payload = { cinema_ids };
            let response = await MarketingService.getCinemawiseScreenList(
              payload
            );
            const { data } = response;
            if (data.status && data.Records.length) {
              this.cinemaSettingsSection.cinemaSettings[
                index
              ].allowedScreenList = data.Records;
            } else {
              console.log(data.message);
            }
          } else {
            this.cinemaSettingsSection.cinemaSettings[
              index
            ].allowedScreenList = [];
          }
        } catch (error) {
          this._CatchError(error);
        } finally {
          if (loader) {
            loader.hide();
          }
        }
      },
      async getCinemawiseScreenList(SettingIndex) {
        let loader = this.$loading.show();
        try {
          let cinema_ids = [];

          if (
            this.cinemaSettingsSection.cinemaSettings[SettingIndex]
              .selectedCinema.length
          ) {
            cinema_ids = this.cinemaSettingsSection.cinemaSettings[
              SettingIndex
            ].selectedCinema.map((cinema) => cinema.cine_id);
            // .join(",")
          }

          let payload = { cinema_ids };
          let response = await MarketingService.getCinemawiseScreenList(
            payload
          );
          const { data } = response;
          if (data.status && data.Records.length) {
            this.cinemaSettingsSection.cinemaSettings[
              SettingIndex
            ].allowedScreenList = data.Records;
          } else {
            console.log(data.message);
          }
        } catch (error) {
          this._CatchError(error);
        } finally {
          if (loader) {
            loader.hide();
          }
        }
      },
      async updateRejectedCinemaIds(settingsIndex, event, action) {
        let pvcsIndex = -1;
        if (this.cinemaSettingsSection.cinemaSettings[settingsIndex].pvcs_id) {
          pvcsIndex = this.sendPayload.cinemaSettingsList.findIndex(
            (screenObj) =>
              screenObj.pvcs_id ==
              this.cinemaSettingsSection.cinemaSettings[settingsIndex].pvcs_id
          );
        }
        if (action == "add") {
          this.cinemaSettingsSection.rejectedCinemaIds.push(event.cine_id);
          // await this.getCinemawiseScreenList(settingsIndex);
          if (this.cinemaSettingsSection.cinemaSettings.length) {
            this.cinemaSettingsSection.cinemaSettings.forEach((row) => {
              let cinemaIndex = -1;
              cinemaIndex = row.allowedCinemaList.findIndex(
                (list) => list.cine_id == event.cine_id
              );
              if (cinemaIndex >= 0) {
                row.allowedCinemaList.splice(cinemaIndex, 1);
              }
            });
          }
        } else {
          let idIndex = this.cinemaSettingsSection.rejectedCinemaIds.indexOf(
            event.cine_id
          );
          if (idIndex >= 0) {
            this.cinemaSettingsSection.rejectedCinemaIds.splice(idIndex, 1);
          }
          // await this.getCinemawiseScreenList(settingsIndex)
          this.cinemaSettingsSection.cinemaSettings[
            settingsIndex
          ].selectedScreens = this.cinemaSettingsSection.cinemaSettings[
            settingsIndex
          ].selectedScreens.filter(
            (screen) => screen.cinema_id != event.cine_id
          );

          if (pvcsIndex >= 0) {
            if (
              this.cinemaSettingsSection.cinemaSettings[settingsIndex]
                .selectedScreens.length
            ) {
              this.sendPayload.cinemaSettingsList[
                pvcsIndex
              ].all_screen_ids = this.cinemaSettingsSection.cinemaSettings[
                settingsIndex
              ].selectedScreens
                .map((screen) => screen.screen_id)
                .join(",");
            } else {
              this.sendPayload.cinemaSettingsList[pvcsIndex].all_screen_ids =
                "";
            }
          }
          if (this.cinemaSettingsSection.cinemaSettings.length) {
            this.cinemaSettingsSection.cinemaSettings.forEach((row) => {
              let cinemaIndex = -1;
              cinemaIndex = row.allowedCinemaList.findIndex(
                (list) => list.cine_id == event.cine_id
              );
              if ((cinemaIndex = -1)) {
                row.allowedCinemaList.push(event);
              }
            });
          }
        }
      },
      // async updateSendPayloadCinemaSection(settingsIndex, event) {
      //   let pvcsIndex = -1;
      //   console.log("event=>", event, "from cinema selection input")
      //   this.updateScreenListCinemaWise(event, settingsIndex);

      //   if (this.cinemaSettingsSection.cinemaSettings[settingsIndex].pvcs_id) {
      //     pvcsIndex = this.sendPayload.cinemaSettingsList.findIndex(screenObj => screenObj.pvcs_id == this.cinemaSettingsSection.cinemaSettings[settingsIndex].pvcs_id)
      //   }
      //   if (pvcsIndex >= 0 && event.length) {
      //     this.sendPayload.cinemaSettingsList[pvcsIndex].all_cinema_id = [...this.sendPayload.cinemaSettingsList[pvcsIndex].all_cinema_id, event.cine_id]
      //     this.cinemaSettingsSection.availableCinemasList.push(event.cine_id)
      //   } else {
      //     this.sendPayload.cinemaSettingsList.push({
      //       all_cinema_id: event.cine_id
      //     })
      //   }

      // },
      updateSendPayload: function(event, index) {
        let fnbIndex = -1;
        if (this.offerTypes.fnbItemDiscounts[index].pv_fnb_id) {
          fnbIndex = this.sendPayload.fnbDiscountdata.findIndex(
            (row) =>
              row.pv_fnb_id == this.offerTypes.fnbItemDiscounts[index].pv_fnb_id
          );
        }
        if (fnbIndex >= 0) {
          this.sendPayload.fnbDiscountdata[fnbIndex].pv_fnb_item_offer =
            event.data;
        }
      },
      downloadImageSignage(obj, index) {
        let imgPath = obj.imageUrl;
        let fileName = ``;
        let extension_array = imgPath.split(".");
        let actual_extension = extension_array[extension_array.length - 1];
        fileName = `Offer_Signage_${obj.width}x${obj.height}.${actual_extension}`;
        this._downloadImagePath(imgPath, fileName);
      },
      deleteImageSignage(index) {
        this.signageImageData.signageContainer[index].imageUrl = "";
      },
      removeSignage(index) {
        this.signageImageData.signageContainer.splice(index, 1);
      },
      addSignageData() {
        this.signageImageData.signageContainer.push({
          width: "",
          height: "",
          imageUrl: "",
        });
      },
      handleDistributorRowAction(type, index = null) {
        if (type === "add") {
          this.distributorSection.distributorData.push({
            selectedCinema: {},
            selectedSeatTypes: [],
            selectedTickets: [],
            pvds_dist_value: null,
          });
        } else {
          if (this.sendPayload.distributorShareData.length) {
            let pvdsIndex = this.sendPayload.distributorShareData.findIndex(
              (shareObj) =>
                shareObj.pvds_id ==
                this.distributorSection.distributorData[index].pvds_id
            );

            if (pvdsIndex >= 0) {
              this.sendPayload.distributorShareData[pvdsIndex][
                "pvds_is_active"
              ] = "N";
            }
          }
          this.distributorSection.distributorData.splice(index, 1);
        }
      },
      async getOfferPromotionVoucherData() {
        let loader;
        try {
          if (!this.offer_id) {
            this.$toasted.show("offer_id is required");
            return;
          }

          let payload = {
            offer_id: this.offer_id,
          };
          loader = this.$loading.show();
          let response = await MarketingService.getSingleOfferVouchers(payload);
          const { data } = response;

          if (data && data.status) {
            const {
              offerSettings,
              offersContentData,
              moviesData,
              daysData,
              bankOfferData,
              offerCriteriaData,
              cinemaScreenSettingsRecords = [],
              distributorShareData = [],
              promoVoucherCinemaData = {
                data: [],
                availableCinemas: [],
              },
            } = data;

            this.os_is_voucher = offerSettings.os_is_voucher;
            this.titleName =
              offerSettings.os_is_voucher == "Y" ? "Voucher" : "Offer";
            this.offer = {
              os_is_active: offerSettings.os_is_active,
              offer_title: offerSettings.offer_title,
              offer_code: offerSettings.offer_code,
              offer_start_date_time: offerSettings.offer_start_date_time,
              offer_end_date_time: offerSettings.offer_end_date_time,
              offer_start_time: offerSettings.offer_start_time || "06.00",
              offer_end_time: offerSettings.offer_end_time || "05.59",
              offer_group_type_id: offerSettings.offer_group_type_id,
              offer_description_text: offerSettings.offer_description_text,
              is_offer_auth_required: offerSettings.is_offer_auth_required,
              visible_on_web: offerSettings.visible_on_web,
              is_redemption: offerSettings.is_redemption,
              selectedOfferGroupType: offerSettings.selectedOfferGroupType,
            };
            this.offerMovieConfiguration = {
              os_is_foreign_movie_applicable:
                offerSettings.os_is_foreign_movie_applicable,
              os_movie_mf_id: offerSettings.os_movie_mf_id,
              os_is_movie_applicable: offerSettings.os_is_movie_applicable,
              selectedMovieFormats: offerSettings.os_movie_mf_id
                ? this.masterData.movieFormats.filter((obj) =>
                    offerSettings.os_movie_mf_id
                      .split(",")
                      .includes(String(obj.mf_id))
                  )
                : [],
              // selectedParticularMovies: moviesData.length
              //   ? this.masterData.movieList.filter((obj) =>
              //       moviesData.map((movie) => movie.md_id).includes(obj.md_id)
              //     )
              //   : [],
              selectedParticaularMovies: moviesData.length ? moviesData : [],
              movies_applicable_status:
                offerSettings.os_is_movie_applicable == "Y"
                  ? "movies_applicable"
                  : "movies_not_applicable",
              start_show_time: moviesData.length
                ? moviesData[0].start_show_time
                : "",
              end_show_time: moviesData.length
                ? moviesData[0].end_show_time
                : "",
            };

            this.sendPayload.movieList = moviesData.length ? moviesData : [];
            if (
              promoVoucherCinemaData &&
              promoVoucherCinemaData.data &&
              promoVoucherCinemaData.data.length
            ) {
              this.cinemaSettingsSection.availableCinemasList =
                promoVoucherCinemaData.availableCinemas;
              this.cinemaSettingsSection.cinemaSettings =
                promoVoucherCinemaData.data;
              this.sendPayload.cinemaSettingsList = cinemaScreenSettingsRecords;
            }

            if (offerSettings.pg_promo_code) {
              let data = JSON.parse(offerSettings.pg_promo_code);
              this.offerContent.pg_promo_code = data;
            }

            if (offersContentData.length) {
              offersContentData.forEach((contentObj) => {
                let masterContentIndex = this.offerContent.offerContentArray.findIndex(
                  (masterContentObj) => {
                    return masterContentObj.langaugeId == contentObj.lang_id;
                  }
                );

                if (masterContentIndex >= 0) {
                  this.offerContent.offerContentArray[masterContentIndex] = {
                    ...this.offerContent.offerContentArray[masterContentIndex],
                    ...contentObj,
                  };
                }
              });
            }

            this.voucherSettting = {
              oc_redemptions_per_patron:
                offerCriteriaData.oc_redemptions_per_patron,
              oc_total_redemptions: offerCriteriaData.oc_total_redemptions,
            };

            this.offerDaysConfiguration = {
              offer_applicable_on_all_day:
                offerSettings.offer_applicable_on_all_day,
              weekDays: daysData.sunday
                ? {
                    selectAll: offerSettings.offer_applicable_on_all_day,
                    ...daysData,
                  }
                : {
                    selectAll: "Y",
                    sunday: "Y",
                    monday: "Y",
                    tuesday: "Y",
                    wednesday: "Y",
                    thursday: "Y",
                    friday: "Y",
                    saturday: "Y",
                  },
            };
            this.offerSplitConfiguration = {
              client_share_value: offerSettings.client_share_value,
              client_share_is_percentage:
                offerSettings.client_share_is_percentage,
              offer_dist_share_threshold:
                offerSettings.offer_dist_share_threshold,
              selectedClient: offerSettings.selectedClient || {},
            };
            this.offerSettingConfiguration = {
              is_bank_offer: offerSettings.is_bank_offer,
              report_full_amount: offerSettings.report_full_amount,
              report_full_amount_special_rc:
                offerSettings.report_full_amount_special_rc,
              has_o_reporting_percent: offerSettings.has_o_reporting_percent,
              o_reporting_percent: offerSettings.o_reporting_percent,
              selectedCard: [],
            };
            (this.offerTypes.is_employee_offer =
              offerSettings.is_employee_offer),
              //start set reemption outlet data

              (this.redemptionOutletData = {
                offer_redeem_at_online: offerSettings.offer_redeem_at_online,
                offer_redeem_at_boxoffice:
                  offerSettings.offer_redeem_at_boxoffice,
                offer_redeem_at_concession:
                  offerSettings.offer_redeem_at_concession,
                offer_applicable_on:
                  offerSettings.offer_applicable_on_gross_amount == "Y"
                    ? "gross"
                    : "net",
                offer_applicable_on_gross_amount:
                  offerSettings.offer_applicable_on_gross_amount,
                offer_applicable_on_net_amount:
                  offerSettings.offer_applicable_on_net_amount,
                selectedUsers:
                  offerSettings.selectedUsers &&
                  offerSettings.selectedUsers.length
                    ? offerSettings.selectedUsers
                    : [],
              });
            //end set reemption outlet data

            //start singage image
            this.signageImageData.signageContainer =
              offerSettings.signage_image;
            //end of signage image

            //start set distributor share  value
            if (distributorShareData.length) {
              this.sendPayload.distributorShareData = distributorShareData;
              distributorShareData.forEach((distributorObj, index) => {
                let distributorShareObject = {
                  pvds_id: distributorObj.pvds_id,
                  pvds_dist_value: distributorObj.pvds_dist_value,
                  pvds_is_active: distributorObj.pvds_is_active,
                  selectedCinema: {
                    cine_id: distributorObj.pvds_cinema_id,
                    cine_name: distributorObj.cine_name,
                  },
                };
                if (distributorObj.pvds_all_seat_type_id) {
                  distributorShareObject.selectedSeatTypes = distributorObj.pvds_all_seat_type_id
                    .split(",")
                    .map((seatObj) => {
                      return this.masterData.seatGroups.length
                        ? this.masterData.seatGroups.find(
                            (cinemaSeatObj) => cinemaSeatObj.sstg_id == seatObj
                          )
                        : { sstg_id: seatObj };
                    });
                }
                if (distributorObj.pvds_ticket_type_id) {
                  distributorShareObject.selectedTickets = distributorObj.pvds_ticket_type_id
                    .split(",")
                    .map((ticketObj) => {
                      return this.masterData.ticketTypesData.length
                        ? this.masterData.ticketTypesData.find(
                            (cinemaTicketObj) =>
                              cinemaTicketObj.tt_id == ticketObj
                          )
                        : { tt_id: ticketObj };
                    });
                }

                this.distributorSection.distributorData.push(
                  distributorShareObject
                );
              });
            }
            //end set distributor share  value

            if (bankOfferData) {
              if (!this.offerSettingConfiguration.bankDetails) {
                this.offerSettingConfiguration.bankDetails = {
                  selectedBank: "",
                  bank_id: null,
                  card_type_ids: "",
                  boc_id: null,
                };
                this.offerSettingConfiguration.selectedCard = [];
              }
              this.offerSettingConfiguration.bankDetails.selectedBank =
                bankOfferData.selectedBank;

              this.offerSettingConfiguration.selectedCard =
                bankOfferData.selectedCards;

              this.offerSettingConfiguration.bankDetails.bank_id =
                bankOfferData.bank_id;

              this.offerSettingConfiguration.bankDetails.boc_id =
                bankOfferData.selectedBank.boc_id;
            }

            switch (offerSettings.offer_type_id) {
              case 8:
                this.offerTypes.selectedOfferType = "fixedDiscount";
                this.offerTypes.fixedDiscount = {
                  oc_buy_no_of_ticket: offerCriteriaData.oc_buy_no_of_ticket,
                  oc_discount_value: offerCriteriaData.oc_discount_value,
                  oc_discount_value_is_percentage:
                    offerCriteriaData.oc_discount_value_is_percentage,
                  oc_max_discount_amount:
                    offerCriteriaData.oc_max_discount_amount,
                  oc_min_ticket_price: offerCriteriaData.oc_min_ticket_price,
                  oc_min_fnb_price: offerCriteriaData.oc_min_fnb_price,
                  min_amount_channel_wise:
                    offerCriteriaData.min_amount_channel_wise,
                };
                break;
              case 1:
                this.offerTypes.selectedOfferType = "buyAndGetFreeTickets";

                this.offerTypes.buyAndGetFreeTickets = {
                  oc_buy_no_of_ticket:
                    offerCriteriaData.oc_buy_no_of_ticket || null,
                  oc_get_free_ticket:
                    offerCriteriaData.oc_get_free_ticket || null,
                  oc_min_ticket_price:
                    offerCriteriaData.oc_min_ticket_price || null,
                  oc_max_no_of_ticket_per_transaction:
                    offerCriteriaData.oc_max_no_of_ticket_per_transaction ||
                    null,
                  oc_combine_with_other_offers:
                    offerCriteriaData.oc_combine_with_other_offers || "",
                };
                break;
              case 2:
                this.offerTypes.selectedOfferType = "discount";
                this.offerTypes.discount = {
                  oc_buy_no_of_ticket: offerCriteriaData.oc_buy_no_of_ticket,
                  oc_discount_value: offerCriteriaData.oc_discount_value,
                  oc_discount_value_is_percentage:
                    offerCriteriaData.oc_discount_value_is_percentage,
                  oc_max_discount_amount:
                    offerCriteriaData.oc_max_discount_amount,
                };
                break;
              case 7:
                this.offerTypes.selectedOfferType = "loyalitycustomers";
                this.offerTypes.loyalityProgramOffer = {
                  oc_buy_no_of_ticket: offerCriteriaData.oc_buy_no_of_ticket,
                  oc_discount_value: offerCriteriaData.oc_discount_value,
                  oc_discount_value_is_percentage:
                    offerCriteriaData.oc_discount_value_is_percentage,
                  oc_max_discount_amount:
                    offerCriteriaData.oc_max_discount_amount,
                };
                break;
              case 3:
                this.offerTypes.selectedOfferType = "buyAndGetCombo";
                this.offerTypes.buyAndGetCombo.offerApplicableAt =
                  offerCriteriaData.oc_is_combo_with_fnb == "Y"
                    ? "fAndb"
                    : "boxOffice";
                if (offerCriteriaData.oc_is_combo_with_fnb == "Y") {
                  this.offerTypes.buyAndGetCombo.F_And_B = {
                    oc_buy_item_count: offerCriteriaData.oc_buy_item_count,
                    oc_get_item_count: offerCriteriaData.oc_get_item_count,
                    oc_buy_item_id: offerCriteriaData.oc_buy_item_id,
                    oc_get_item_id: offerCriteriaData.oc_get_item_id,
                    oc_is_combo_free: offerCriteriaData.oc_is_combo_free,
                    oc_is_combo_with_fnb:
                      offerCriteriaData.oc_is_combo_with_fnb,
                    oc_discount_value_is_percentage:
                      offerCriteriaData.oc_discount_value_is_percentage,
                    oc_discount_value: offerCriteriaData.oc_discount_value,
                    selectedBuyFnbItem: offerCriteriaData.selectedBuyfnbItem,
                    selectedGetFnbItem: offerCriteriaData.selectedGetfnbItem,
                  };
                } else {
                  this.offerTypes.buyAndGetCombo.boxOffice = {
                    oc_buy_no_of_ticket: offerCriteriaData.oc_buy_no_of_ticket,
                    oc_get_item_id: offerCriteriaData.oc_get_item_id,
                    oc_is_combo_free: offerCriteriaData.oc_is_combo_free,
                    oc_discount_value: offerCriteriaData.oc_discount_value,
                    oc_discount_value_is_percentage:
                      offerCriteriaData.oc_discount_value_is_percentage,
                    selectedGetFnbItem: offerCriteriaData.selectedGetfnbItem,
                  };
                }
                break;
              case 9:
                this.offerTypes.selectedOfferType = "fixedPriceTicketFnb";
                this.offerTypes.buyTicketFnbFixedPrice = {
                  oc_buy_no_of_ticket: offerCriteriaData.oc_buy_no_of_ticket,
                  // oc_ticket_at_price: offerCriteriaData.oc_ticket_at_price,
                  oc_discount_value: offerCriteriaData.oc_discount_value,
                  oc_max_no_of_ticket_per_transaction:
                    offerCriteriaData.oc_max_no_of_ticket_per_transaction,
                  oc_is_combo_with_fnb: offerCriteriaData.oc_is_combo_with_fnb,
                  fnb_group_data: offerCriteriaData.fnb_group_data,
                };
                break;
              case 10:
                this.offerTypes.selectedOfferType = "buyAndgetOffOnAnother";
                this.offerTypes.buyAndgetOffOnAnother = {
                  oc_buy_no_of_ticket: offerCriteriaData.oc_buy_no_of_ticket,
                  oc_discount_value: offerCriteriaData.oc_discount_value,
                  oc_discount_value_is_percentage:
                    offerCriteriaData.oc_discount_value_is_percentage,
                  oc_offer_on_higher_amount:
                    offerCriteriaData.oc_offer_on_higher_amount,
                  oc_max_no_of_ticket_per_transaction:
                    offerCriteriaData.oc_max_no_of_ticket_per_transaction,
                };
                break;
              case 11:
                this.offerTypes.selectedOfferType = "fnbItemDiscounts";
                if (offerCriteriaData.fnbDiscountData) {
                  this.offerTypes.fnbItemDiscounts =
                    offerCriteriaData.fnbDiscountData;
                  this.sendPayload.fnbDiscountdata = offerCriteriaData.fnbDiscountData.map(
                    (row) => {
                      return {
                        ...row,
                        selectedFnbItem: row.selectedFnbItem,
                      };
                    }
                  );
                } else {
                  this.offerTypes.fnbItemDiscounts = [
                    {
                      pv_fnb_item_code: "",
                      pv_fnb_item_offer: null,
                      selectedFnbItem: {},
                    },
                  ];
                }
                break;
            }
          } else {
            this.$toasted.show(data.message);
          }
        } catch (error) {
          this._CatchError(error);
        } finally {
          if (loader) {
            loader.hide();
          }
        }
      },
      updateOffer() {
        this.submit.offer = true;
        if (!this.offer.offer_title) {
          return this.$toasted.show("offer title is required");
        }
        if (
          moment(this.offer.offer_start_date_time, moment.ISO_8601).isAfter(
            moment(this.offer.offer_end_date_time, moment.ISO_8601)
          )
        ) {
          return this.$toasted.show("Please Enter Proper Dates");
        }
        let offers = {
          //offer
          os_is_active: this.offer.os_is_active,
          offer_title: this.offer.offer_title,
          offer_code: this.offer.offer_code,
          offer_group_type_id: this.offer.selectedOfferGroupType
            ? this.offer.selectedOfferGroupType.ogt_id
            : 1,
          offer_start_date_time: moment(
            this.offer.offer_start_date_time
          ).format("YYYY-MM-DD HH:mm"),
          offer_end_date_time: moment(this.offer.offer_end_date_time).format(
            "YYYY-MM-DD HH:mm"
          ),
          offer_start_time: this.offer.offer_start_time,
          offer_end_time: this.offer.offer_end_time,
          offer_description_text: this.offer.offer_description_text,
          is_offer_auth_required: this.offer.is_offer_auth_required,
          visible_on_web: this.offer.visible_on_web,
          is_redemption: this.offer.is_redemption,
        };
        let payload = { offers };
        this.onSubmit(payload, "offersSection");
      },
      updateSinage() {
        let offers = {
          signage_image: JSON.stringify(this.signageImageData.signageContainer),
        };
        let payload = { offers };
        this.onSubmit(payload, "signageImageSection");
      },
      updateVoucherSetting() {
        let offerCriteriaData = {
          oc_redemptions_per_patron: this.voucherSettting
            .oc_redemptions_per_patron,
          oc_total_redemptions: this.voucherSettting.oc_total_redemptions,
        };
        let payload = { offerCriteriaData };
        this.onSubmit(payload, "voucherSettingSection");
      },
      updateMovieSection() {
        if (
          this.offerMovieConfiguration.os_is_movie_applicable == "N" &&
          !this.offerMovieConfiguration.selectedParticaularMovies.length
        ) {
          return this.$toasted.show(
            "Please select atleast one not applicable movie"
          );
        }

        let moviesData = {
          moviesDetails: this.offerMovieConfiguration.selectedParticaularMovies,
          start_show_time: this.offerMovieConfiguration.start_show_time,
          end_show_time: this.offerMovieConfiguration.end_show_time,
        };

        let offersMovieSingleSettings = {
          os_is_foreign_movie_applicable: this.offerMovieConfiguration
            .os_is_foreign_movie_applicable,
          os_movie_mf_id:
            this.offerMovieConfiguration.selectedMovieFormats.length > 0
              ? this.offerMovieConfiguration.selectedMovieFormats
                  .map((format) => format.mf_id)
                  .join(",")
              : "",
          os_is_movie_applicable: this.offerMovieConfiguration
            .os_is_movie_applicable,
        };
        let newMoviesList = this.offerMovieConfiguration.selectedParticaularMovies.filter(
          (newMoviesObj) => {
            return (
              !Object(newMoviesObj).hasOwnProperty("pvms_id") ||
              !newMoviesObj.pvms_id
            );
          }
        );

        if (newMoviesList.length > 0) {
          this.sendPayload.movieList = [
            ...this.sendPayload.movieList,
            ...newMoviesList,
          ];
        }

        let offersMovie = this.sendPayload.movieList.length
          ? this.sendPayload.movieList.map((offersMovieObj) => {
              let obj = {
                ...offersMovieObj,
                movie_detail_id: offersMovieObj.md_id,
                end_show_time: this.offerMovieConfiguration.end_show_time,
                start_show_time: this.offerMovieConfiguration.start_show_time,
              };
              // if (offersMovieObj.pvms_id) {
              //   obj.pvms_id = offersMovieObj.pvms_id;
              //   obj.offer_id = offersMovieObj.offer_id;
              //   obj.voucher_id = offersMovieObj.voucher_id;
              //   obj.voucher_title = offersMovieObj.offer_title;
              //   obj.movie_detail_id = offersMovieObj.md_id;
              //   obj.offer_start_date_time = offersMovieObj.offer_start_date_time;
              //   obj.start_show_time =
              //     this.offerMovieConfiguration.start_show_time;
              //   obj.offer_end_date_time = offersMovieObj.offer_end_date_time;
              //   obj.end_show_time = this.offerMovieConfiguration.end_show_time;
              //   obj.pvms_is_active = offersMovieObj.pvms_is_active;
              // } else {
              //   obj.voucher_title = this.offer.offer_title;
              //   obj.md_id = offersMovieObj.md_id;
              //   obj.offer_start_date_time = this.offer.offer_start_date_time;
              //   obj.start_show_time =
              //     this.offerMovieConfiguration.start_show_time;
              //   obj.offer_end_date_time = this.offer.offer_end_date_time;
              //   obj.end_show_time = this.offerMovieConfiguration.end_show_time;
              // }
              return obj;
            })
          : [];
        let payload = { offersMovie, offersMovieSingleSettings };

        this.onSubmit(payload, "offersMovieSection");
      },

      updateDayssection() {
        if (this.offerDaysConfiguration.TrueFalseCount == 7) {
          return this.$toasted.show("Please select atleast one day of week ");
        }
        let offerDays = this.offerDaysConfiguration.weekDays;
        const { selectAll, ...allWeekDays } = offerDays;
        let payload = {
          offerDays: allWeekDays,
          offers: {
            offer_applicable_on_all_day: this.offerDaysConfiguration
              .offer_applicable_on_all_day,
          },
        };
        this.onSubmit(payload, "offersDaysSection");
      },

      updateSplitConfig() {
        if (!this.offerSplitConfiguration.client_share_value) {
          return this.$toasted.show("Please enter share value ");
        }
        let offersClient = {
          client_id: this.offerSplitConfiguration.selectedClient
            ? this.offerSplitConfiguration.selectedClient.client_id
            : null,
          client_share_value: this.offerSplitConfiguration.client_share_value,
          client_share_is_percentage: this.offerSplitConfiguration
            .client_share_is_percentage,
          offer_dist_share_threshold: this.offerSplitConfiguration
            .offer_dist_share_threshold,
        };
        let payload = { offersClient };
        this.onSubmit(payload, "offersClientSection");
      },
      updateSignageImageSection() {},

      updateotherOffersSettingsSection() {
        if (this.offerSettingConfiguration.is_bank_offer == "Y") {
          if (!this.offerSettingConfiguration.bankDetails.selectedBank) {
            return this.$toasted.show("select bank for bank offer ");
          }
        }
        if (this.offerSettingConfiguration.is_bank_offer == "Y") {
          if (!this.offerSettingConfiguration.selectedCard.length) {
            return this.$toasted.show("select card type");
          }
        }

        let otherSettings = {
          is_bank_offer: this.offerSettingConfiguration.is_bank_offer,
          report_full_amount: this.offerSettingConfiguration.report_full_amount,
          report_full_amount_special_rc: this.offerSettingConfiguration
            .report_full_amount_special_rc,
          has_o_reporting_percent: this.offerSettingConfiguration
            .has_o_reporting_percent,
          o_reporting_percent: this.offerSettingConfiguration
            .o_reporting_percent,
        };

        let bankOfferData = {
          boc_id: this.offerSettingConfiguration.bankDetails.boc_id,
          bank_id: this.offerSettingConfiguration.bankDetails["bank_id"],
          card_type_ids:
            this.offerSettingConfiguration.selectedCard.length > 0
              ? this.offerSettingConfiguration.selectedCard
                  .map((card) => card.card_id)
                  .join(",")
              : "",
        };
        let payload = { otherSettings, bankOfferData };
        this.onSubmit(payload, "otherOffersSettingsSection");
      },
      updateOfferCriteria() {
        let offerCriteriaData = {
          oc_redemptions_per_patron: this.voucherSettting
            .oc_redemptions_per_patron,
          oc_total_redemptions: this.voucherSettting.oc_total_redemptions,
        };
        console.log("check1=>", offerCriteriaData);
        let fnbDiscountData = [];
        let offers = {};

        let validationResponse;
        switch (this.offerTypes.selectedOfferType) {
          case "fixedDiscount":
            validationResponse = this.fixedDiscountValidator();
            if (!validationResponse.status) {
              return this.$toasted.show(validationResponse.mess);
            }
            offerCriteriaData = {
              ...offerCriteriaData,
              ...this.offerTypes.fixedDiscount,
            };
            console.log("check2=>", offerCriteriaData);

            offerCriteriaData.offer_setting_id = this.offer_id;
            offers.offer_type_id = 8;
            offers.is_employee_offer = this.offerTypes.is_employee_offer;

            break;
          case "buyAndGetFreeTickets":
            validationResponse = this.buyAndGetFreeTicketsValidator();
            if (!validationResponse.status) {
              return this.$toasted.show(validationResponse.mess);
            }
            offerCriteriaData = {
              ...offerCriteriaData,
              ...this.offerTypes.buyAndGetFreeTickets,
            };
            console.log("check2=>", offerCriteriaData);

            offerCriteriaData.offer_setting_id = this.offer_id;
            offers.offer_type_id = 1;
            offers.is_employee_offer = "N";

            break;
          case "discount":
            validationResponse = this.discountValidator();
            if (!validationResponse.status) {
              return this.$toasted.show(validationResponse.mess);
            }
            offerCriteriaData = {
              ...offerCriteriaData,
              ...this.offerTypes.discount,
            };
            offerCriteriaData.offer_setting_id = this.offer_id;
            offers.offer_type_id = 2;
            offers.is_employee_offer = "N";

            break;
          case "loyalitycustomers":
            validationResponse = this.loyalitycustomersValidator();
            if (!validationResponse.status) {
              return this.$toasted.show(validationResponse.mess);
            }
            offerCriteriaData = {
              ...offerCriteriaData,
              ...this.offerTypes.loyalityProgramOffer,
            };
            offerCriteriaData.offer_setting_id = this.offer_id;
            offers.offer_type_id = 7;
            offers.is_employee_offer = "N";

            break;
          case "buyAndGetCombo":
            validationResponse = this.buyAndGetComboValidatore();
            if (!validationResponse.status) {
              return this.$toasted.show(validationResponse.mess);
            }
            if (
              this.offerTypes.buyAndGetCombo.offerApplicableAt == "boxOffice"
            ) {
              offerCriteriaData = {
                ...offerCriteriaData,
                ...this.offerTypes.buyAndGetCombo.boxOffice,
              };
              // offerCriteriaData.isBo = true;
              if (this.offerTypes.buyAndGetCombo.boxOffice.selectedGetFnbItem) {
                offerCriteriaData.oc_get_item_id = this.offerTypes.buyAndGetCombo.boxOffice.selectedGetFnbItem.item_id;
                offerCriteriaData.oc_get_item_code = this.offerTypes.buyAndGetCombo.boxOffice.selectedGetFnbItem.item_code;
                delete offerCriteriaData.selectedGetFnbItem;
              }
            } else {
              offerCriteriaData = {
                ...offerCriteriaData,
                ...this.offerTypes.buyAndGetCombo.F_And_B,
              };
              // offerCriteriaData.isBo = false;

              if (this.offerTypes.buyAndGetCombo.F_And_B.selectedBuyFnbItem) {
                offerCriteriaData.oc_buy_item_id = this.offerTypes.buyAndGetCombo.F_And_B.selectedBuyFnbItem.item_id;
                offerCriteriaData.oc_buy_item_code = this.offerTypes.buyAndGetCombo.F_And_B.selectedBuyFnbItem.item_code;
                delete offerCriteriaData.selectedBuyFnbItem;
              }
              if (this.offerTypes.buyAndGetCombo.F_And_B.selectedGetFnbItem) {
                offerCriteriaData.oc_get_item_id = this.offerTypes.buyAndGetCombo.F_And_B.selectedGetFnbItem.item_id;
                offerCriteriaData.oc_get_item_code = this.offerTypes.buyAndGetCombo.F_And_B.selectedGetFnbItem.item_code;
                delete offerCriteriaData.selectedGetFnbItem;
              }
            }
            offerCriteriaData.oc_is_combo_with_fnb =
              this.offerTypes.buyAndGetCombo.offerApplicableAt == "boxOffice"
                ? "N"
                : "Y";
            offerCriteriaData.offer_setting_id = this.offer_id;
            offers.offer_type_id = 3;
            offers.is_employee_offer = "N";

            break;
          case "fixedPriceTicketFnb":
            validationResponse = this.fixedPriceTicketFnbValidatore();
            if (!validationResponse.status) {
              return this.$toasted.show(validationResponse.mess);
            }

            offerCriteriaData = {
              ...offerCriteriaData,
              ...this.offerTypes.buyTicketFnbFixedPrice,
            };

            let fnbGroupData = offerCriteriaData.fnb_group_data.length
              ? offerCriteriaData.fnb_group_data.map((item) => {
                  let obj = { ...item };
                  if (item.selectedFnbItem.hasOwnProperty("item_id")) {
                    obj.oc_buy_item_id = item.selectedFnbItem.item_id;
                    obj.oc_buy_item_code = item.selectedFnbItem.item_code;
                  }
                  return obj;
                })
              : [];

            offerCriteriaData.fnb_group_data = JSON.stringify(fnbGroupData);
            offerCriteriaData.offer_setting_id = this.offer_id;
            offers.offer_type_id = 9;
            offers.is_employee_offer = "N";
            // Continue with further processing or API call

            break;
          case "buyAndgetOffOnAnother":
            validationResponse = this.buyAndgetOffOnAnotherValidatore();
            if (!validationResponse.status) {
              return this.$toasted.show(validationResponse.mess);
            }
            offerCriteriaData = {
              ...offerCriteriaData,
              ...this.offerTypes.buyAndgetOffOnAnother,
            };
            offerCriteriaData.offer_setting_id = this.offer_id;
            offers.offer_type_id = 10;
            offers.is_employee_offer = "N";

            break;

          case "fnbItemDiscounts":
            // offerCriteriaData = {
            let newFnbData = this.offerTypes.fnbItemDiscounts.filter(
              (fnbRow) => !fnbRow.pv_fnb_id
            );
            console.log("newData=>", newFnbData);
            let allFnbData = [
              ...this.sendPayload.fnbDiscountdata,
              ...newFnbData,
            ];
            // let fnbDiscountData=[];

            if (allFnbData.length) {
              fnbDiscountData = allFnbData.map((fnbItem) => {
                let obj = {
                  pv_fnb_item_code: "",
                  pv_fnb_item_offer: null,
                  pv_fnb_id: null,
                  pv_fnb_is_active: "Y",
                };

                fnbItem.selectedFnbItem.hasOwnProperty("item_id") &&
                  (obj.pv_fnb_item_code = fnbItem.selectedFnbItem.item_code);
                fnbItem.pv_fnb_id && (obj.pv_fnb_id = fnbItem.pv_fnb_id);
                fnbItem.pv_fnb_is_active &&
                  (obj.pv_fnb_is_active = fnbItem.pv_fnb_is_active);
                obj.pv_fnb_item_offer = fnbItem.pv_fnb_item_offer;

                return obj;
              });
            }
            console.log("last payload data=>", fnbDiscountData);

            validationResponse = this.fnbItemDiscountsValidatore(
              fnbDiscountData
            );
            if (!validationResponse.status) {
              return this.$toasted.show(validationResponse.mess);
            }
            offers.offer_type_id = 11;
            offers.is_employee_offer = "N";
            break;
        }

        let payload = {
          offerCriteriaData,
          fnbDiscountData,
          offers,
        };
        this.onSubmit(payload, "offerCriteriaSection");
      },
      updateRedemptionOutlet() {
        if (this.redemptionOutletData.selectedUsers.length == 0) {
          return this.$toasted.show(
            `select atleast one user for redemption outlet`
          );
        }
        let offers = {
          // offer_redeem_at_online:
          //   this.redemptionOutletData.offer_redeem_at_boxoffice,
          offer_redeem_at_boxoffice: this.redemptionOutletData
            .offer_redeem_at_boxoffice,
          offer_redeem_at_concession: this.redemptionOutletData
            .offer_redeem_at_concession,
          offer_applicable_on_gross_amount: this.redemptionOutletData
            .offer_applicable_on_gross_amount,
          offer_applicable_on_net_amount: this.redemptionOutletData
            .offer_applicable_on_net_amount,
          redemption_outlets: this.redemptionOutletData.selectedUsers.length
            ? this.redemptionOutletData.selectedUsers
                .map((user) => user.user_id)
                .join(",")
            : "",
        };
        let payload = { offers };
        console.log("payoad=>", payload);
        this.onSubmit(payload, "redemptionOutletSection");
      },
      makeUpdatedDistributorShareSectionData(index, type, action = "", event) {
        let pvdsIndex = -1;
        if (this.distributorSection.distributorData[index].pvds_id) {
          pvdsIndex = this.sendPayload.distributorShareData.findIndex(
            (obj) =>
              obj.pvds_id ==
              this.distributorSection.distributorData[index].pvds_id
          );
        }
        if (type == "cinema" && pvdsIndex >= 0) {
          this.sendPayload.distributorShareData[pvdsIndex].pvds_cinema_id =
            event.cine_id;
        } else if (type == "seatTypes" && pvdsIndex >= 0) {
          this.sendPayload.distributorShareData[
            pvdsIndex
          ].pvds_all_seat_type_id = this.distributorSection.distributorData[
            index
          ].selectedSeatTypes.length
            ? this.distributorSection.distributorData[index].selectedSeatTypes
                .map((seatsData) => seatsData.sstg_id)
                .join(",")
            : "";
        } else if (type == "ticketTypes" && pvdsIndex >= 0) {
          this.sendPayload.distributorShareData[
            pvdsIndex
          ].pvds_ticket_type_id = this.distributorSection.distributorData[index]
            .selectedTickets.length
            ? this.distributorSection.distributorData[index].selectedTickets
                .map((ticketsData) => ticketsData.tt_id)
                .join(",")
            : "";
        } else if (type == "shareValue" && pvdsIndex >= 0) {
          this.sendPayload.distributorShareData[
            pvdsIndex
          ].pvds_dist_value = event;
        }
      },
      updateDistributorSection() {
        if (this.distributorSection.distributorData.length) {
          let newDistributorShareData = this.distributorSection.distributorData.filter(
            (distributorObj) => !distributorObj.pvds_id
          );
          if (newDistributorShareData.length) {
            newDistributorShareData.forEach((distributorObj) => {
              let distributorPaydloadObject = {
                pvds_id: null,
                pvds_is_active: "Y",
                pvds_dist_value: distributorObj.pvds_dist_value,
                pvds_cinema_id: distributorObj.selectedCinema.cine_id,

                pvds_all_seat_type_id: distributorObj.selectedSeatTypes.length
                  ? distributorObj.selectedSeatTypes
                      .map((seatObj) => seatObj.sstg_id)
                      .join(",")
                  : "",

                pvds_ticket_type_id: distributorObj.selectedTickets.length
                  ? distributorObj.selectedTickets
                      .map((ticketObj) => ticketObj.tt_id)
                      .join(",")
                  : "",
              };
              this.sendPayload.distributorShareData.push(
                distributorPaydloadObject
              );
            });
          }
        }
        let payload = {
          distributorShareData: this.sendPayload.distributorShareData.length
            ? this.sendPayload.distributorShareData
            : [],
        };

        this.onSubmit(payload, "distributorShareSection");
        console.log(this.sendPayload.distributorShareData);
      },
      fixedDiscountValidator() {
        const {
          oc_discount_value,
          oc_max_discount_amount,
        } = this.offerTypes.fixedDiscount;
        if (!oc_discount_value) {
          return { status: false, mess: "enter discount value" };
        } else if (!oc_max_discount_amount) {
          return { status: false, mess: "enter max discount per transection" };
        } else {
          return { status: true, mess: "" };
        }
      },
      buyAndGetFreeTicketsValidator() {
        const {
          oc_buy_no_of_ticket,
          oc_get_free_ticket,
          oc_min_ticket_price,
          oc_max_no_of_ticket_per_transaction,
        } = this.offerTypes.buyAndGetFreeTickets;
        if (!oc_buy_no_of_ticket) {
          return { status: false, mess: "enter buy no of ticket" };
        } else if (!oc_get_free_ticket) {
          return { status: false, mess: "enter get no of free ticket" };
        } else if (!oc_min_ticket_price) {
          return { status: false, mess: "enter min ticket price " };
        } else if (!oc_max_no_of_ticket_per_transaction) {
          return {
            status: false,
            mess: "enter max no of ticket per transection ",
          };
        } else {
          return { status: true, mess: "" };
        }
      },
      discountValidator() {
        const {
          oc_buy_no_of_ticket,
          oc_discount_value,
          oc_max_discount_amount,
        } = this.offerTypes.discount;
        if (!oc_buy_no_of_ticket) {
          return { status: false, mess: "enter buy no of ticket" };
        } else if (!oc_discount_value) {
          return { status: false, mess: "enter discount value" };
        } else if (!oc_max_discount_amount) {
          return { status: false, mess: "enter max discount per transection" };
        } else {
          return { status: true, mess: "" };
        }
      },
      loyalitycustomersValidator() {
        const {
          oc_buy_no_of_ticket,
          oc_discount_value,
          oc_max_discount_amount,
        } = this.offerTypes.loyalityProgramOffer;
        if (!oc_buy_no_of_ticket) {
          return this.$toasted.show("enter buy no of ticket");
        } else if (!oc_discount_value) {
          return { status: false, mess: "enter discount value" };
        } else if (!oc_max_discount_amount) {
          return { status: false, mess: "enter max discount per transection" };
        } else {
          return { status: true, mess: "" };
        }
      },
      buyAndGetComboValidatore() {
        const {
          offerApplicableAt,
          F_And_B,
          boxOffice,
        } = this.offerTypes.buyAndGetCombo;

        if (offerApplicableAt == "fAndb") {
          const {
            oc_buy_item_count,
            oc_get_item_count,
            selectedBuyFnbItem,
            selectedGetFnbItem,
            oc_is_combo_free,
            oc_discount_value,
          } = F_And_B;

          if (!oc_buy_item_count) {
            return { status: false, mess: "enter buy no of item" };
          } else if (
            !selectedBuyFnbItem ||
            !selectedBuyFnbItem.hasOwnProperty("item_id")
          ) {
            return { status: false, mess: "Please select F&B item for Buy" };
          } else if (!oc_get_item_count) {
            return { status: false, mess: "enter get no of item" };
          } else if (
            !selectedGetFnbItem ||
            !selectedGetFnbItem.hasOwnProperty("item_id")
          ) {
            return { status: false, mess: "Please select F&B item for Get" };
          } else if (oc_is_combo_free == "N" && !oc_discount_value) {
            return { status: false, mess: "enter discount value" };
          } else {
            return { status: true, mess: "" };
          }
        } else {
          const {
            oc_buy_no_of_ticket,
            oc_get_item_count,
            selectedGetFnbItem,
            oc_is_combo_free,
            oc_discount_value,
          } = boxOffice;
          if (!oc_buy_no_of_ticket) {
            return { status: false, mess: "enter buy no of ticket" };
          } else if (
            !selectedGetFnbItem ||
            !selectedGetFnbItem.hasOwnProperty("item_id")
          ) {
            return { status: false, mess: "Please select F&B item for Get" };
          } else if (oc_is_combo_free == "N" && !oc_discount_value) {
            return { status: false, mess: "enter discount value" };
          } else {
            return { status: true, mess: "" };
          }
        }
      },
      fixedPriceTicketFnbValidatore() {
        const {
          oc_buy_no_of_ticket,
          oc_discount_value,
          oc_max_no_of_ticket_per_transaction,
          oc_is_combo_with_fnb,
          fnb_group_data,
        } = this.offerTypes.buyTicketFnbFixedPrice;

        if (!oc_buy_no_of_ticket) {
          return { status: false, mess: "enter buy no of ticket" };
        } else if (!oc_discount_value) {
          return { status: false, mess: "enter ticket price" };
        } else if (oc_is_combo_with_fnb == "Y") {
          for (const x of fnb_group_data) {
            if (
              !x.selectedFnbItem ||
              !x.selectedFnbItem.hasOwnProperty("item_id")
            ) {
              return {
                status: false,
                mess: "Please select F&B item for the selected offer type",
              };
            } else if (!x.oc_buy_no_of_item) {
              return {
                status: false,
                mess: "Please enter buy number of items",
              };
            } else if (!x.oc_fnb_at_price) {
              return {
                status: false,
                mess: "Please enter buy item price",
              };
            }
            return { status: true, mess: "" };
          }
        } else {
          return { status: true, mess: "" };
        }
      },
      buyAndgetOffOnAnotherValidatore() {
        const {
          oc_buy_no_of_ticket,
          oc_discount_value,
          oc_max_no_of_ticket_per_transaction,
        } = this.offerTypes.buyAndgetOffOnAnother;
        if (!oc_buy_no_of_ticket) {
          return { status: false, mess: "enter buy no of ticket" };
        } else if (!oc_discount_value) {
          return {
            status: false,
            mess: "enter discount value on another ticket",
          };
        } else if (!oc_max_no_of_ticket_per_transaction) {
          return { status: false, mess: "enter max no of ticket limit" };
        } else {
          return { status: true, mess: "" };
        }
      },
      fnbItemDiscountsValidatore(fnbDiscountData) {
        const { fnbItemDiscounts } = this.offerTypes;
        if (fnbItemDiscounts.length) {
          for (let item of fnbDiscountData) {
            if (!item.pv_fnb_id && !item.pv_fnb_item_code) {
              return {
                status: false,
                mess: "Select F&B item for F&B item discounts offer.",
              };
            } else if (!item.pv_fnb_item_offer) {
              return {
                status: false,
                mess: "emter offer value for fnb item",
              };
            }
          }
        }
        if (fnbDiscountData.length) {
          let checkforActiveFnbRow = fnbDiscountData.some(
            (item) => item.pv_fnb_is_active === "Y"
          );
          if (!checkforActiveFnbRow) {
            return { status: false, mess: "selected fnb item for each row" };
          } else {
            return { status: true, mess: "" };
          }
        } else {
          return { status: false, mess: "fnb discount data requird" };
        }
      },

      updateOfferContent() {
        let offersContent = this.offerContent.offerContentArray;
        let offers = {
          signage_image: JSON.stringify(this.signageImageData.signageContainer),
        };
        let payload = { offersContent, offers };
        this.onSubmit(payload, "offerContentSection");
      },

      async onSubmit(payload = {}, section = "") {
        let loader = this.$loading.show();
        try {
          payload.metaData = {
            os_id: this.offer_id,
            updateSection: section,
            offer_title: this.offer.offer_tite,
          };
          let response = await MarketingService.editOfferVoucherNew(payload);
          let { data } = response;
          if (data && data.status) {
            console.log(data);
            loader.hide();
            this.$toasted.show(data.message);
          } else {
            loader.hide();
            console.log(data.message);
            this.$toasted.show(data.message);
          }
        } catch (error) {
          loader.hide();
          this._CatchError(error);
        }
      },
    },
  };
</script>
<style>
  .greyBackground {
    background-color: #e9ecef;
    border-radius: 15px;
  }

  .whiteBackground {
    background-color: white;
    border-radius: 15px;
  }

  .container {
    position: relative;
    padding: 40px;
    margin-top: 30px;
    border: 1px solid var(--blue);
  }

  .heading {
    position: absolute;
    top: -0.5em;
    left: 30px;
    margin: 0;
    background: #fff;
    padding: 0 10px;
    color: var(--blue);
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/PromotionsAndOffersComponent/editPromotionsAndOffersNewV2.vue